import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import StockProductFontList from '../entities/front-stockproduct'
import appconst from '@/lib/appconst';


interface FrontStockProductState extends ListState<StockProductFontList> {
    stockproductmodel: StockProductFontList,

}

class FrontStockMutations extends ListMutations<StockProductFontList>{

}
class FrontStockProduct extends ListModule<FrontStockProductState, any, StockProductFontList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<StockProductFontList>(),
        loading: false,
        stockproductmodel: StockProductFontList,
        id: 0,
        sku: '',
        safeStockNum: null,
        purchaseCost: null
    }
    actions = {
        async getAll(context: ActionContext<FrontStockProductState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontStockProduct/GetStockProductList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<StockProductFontList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;

        },
        async getInOutStockRecordList(context: any, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontStockProduct/GetInOutStockRecord', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;

        },
        async UpdateStockProductAvailable(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontStockProduct/UpdateStockProductAvailable?stockId=' + payload.data.stockId);
        },
        async UpdateStockProductNotAvailable(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontStockProduct/UpdateStockProductNotAvailable?stockId=' + payload.data.stockId);
        },
        async UpdateStockProductDisable(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontStockProduct/UpdateStockProductDisable?stockId=' + payload.data.stockId);
        },
        async EditSafeStockNum(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/FrontStockProduct/EditSafeStockNum?Id=' + payload.data.id + '&safestockNumber=' + payload.data.safestockNumber);
        },
        async EditStockProduct(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontStockProduct/EditStockProduct', payload.data);
        },
        async cancleCombinationStock(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontStockProduct/CancleCombinationStock', payload.data);
        },
        async EditCombinationStock(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontStockProduct/EditCombinationStock', payload.data);
        },
        //async EditStock(state: any, payload: any) {
        //    let rep = await Ajax.post('/api/services/app/FrontStock/EditStock', payload.data);
        //},
        //async supplementStockInfo(state: any, payload: any) {
        //    let rep = await Ajax.post('/api/services/app/FrontStock/SupplementStockInfo', payload.data);
        //},

    };
    mutations = {
        setCurrentPage(state: FrontStockProductState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FrontStockProductState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const frontstockproduct = new FrontStockProduct();
export default frontstockproduct;